<template>
  <div>
    <!-- Status Manual Send -->
    <vs-chip v-if="statusManualModifier.status" :color="statusManualModifier.color">
      <vs-avatar
        icon-pack="feather"
        :icon="statusManualModifier.icon"
        :color="statusManualModifier.color"
      />
      {{statusManualModifier.text}}
    </vs-chip>
    <!-- Status Email Send -->
    <vs-chip v-if="statusEmailModifier.status" :color="statusEmailModifier.color">
      <vs-avatar
        icon-pack="feather"
        :icon="statusEmailModifier.icon"
        :color="statusEmailModifier.color"
      />
      {{statusEmailModifier.text}}
    </vs-chip>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: null
    },
    statusManual: {
      type: String,
      default: null
    },
    statusEmail: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      listStatusManual: [
        {
          status: null,
          icon: "icon-info",
          color: "",
          text: "Belum Terkirim Secara Manual"
        },
        {
          status: 'pending',
          icon: "icon-clock",
          color: "warning",
          text: "Surat Belum Dikirim"
        },
        {
          status: 'terkirim',
          icon: "icon-user",
          color: "success",
          text: "Terkirim Secara Manual"
        },
      ],
      listStatusEmail: [
        {
          status: null,
          icon: "icon-clock",
          color: "",
          text: "Belum Terkirim Melalui Email"
        },
        {
          status: 'pending',
          icon: "icon-clock",
          color: "warning",
          text: "Surat akan dikirim ke email tujuan"
        },
        {
          status: 'terkirim',
          icon: "icon-mail",
          color: "success",
          text: "Terkirim Melalui Email"
        },
      ],
    };
  },
  computed: {
    statusManualModifier() {
      return this.listStatusManual.find(({ status }) => {
        return status == this.statusManual;
      });
    },
    statusEmailModifier() {
      return this.listStatusEmail.find(({ status }) => {
        return status == this.statusEmail;
      });
    }
  }
};
</script>
